import React from 'react';
import { Box, Typography, List, ListItem, Button } from '@mui/material';

const TaskList = ({ title, tasks, onStartTask, onCompletedTasks, completedTasks }) => {
    const handleTaskComplete = (taskId) => {
      console.log(`Task ID ${taskId} marked as complete`);
      onCompletedTasks(completedTasks + 1);
    };

    return (
        <Box>
          <Typography variant="h6" component="h3" gutterBottom>
            {title}
          </Typography>
          <List>
            {tasks ? (
              tasks.map((task) => (
                <ListItem key={task.id}>
                  <Button
                    variant="contained"
                    onClick={() => handleTaskComplete(task.id)}
                  >
                    Complete
                  </Button>
                  <Typography variant="body1" component="span" sx={{ marginLeft: 3 }}>
                    Priority {task.priority}: {task.title}
                  </Typography>
    
                  {onStartTask && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => onStartTask(task)}
                      sx={{ marginLeft: 2 }}
                    >
                      Start
                    </Button>
                  )}
                </ListItem>
              ))
            ) : (
              <Typography variant="body2" component="span">
                No tasks available
              </Typography>
            )}
          </List>
        </Box>
      );
    };
    
    export default TaskList;
